import { Component, Input, OnInit } from '@angular/core';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { FilterService } from 'app/shared/filter/filter.service';
import { WorkflowService } from 'app/services/workflow.service';
import { environment } from 'environments/environment';
import { CarrierService } from 'app/services/carrier.service';
import { Observable  } from 'rxjs';
import { ApplicationService } from 'app/services/application.service';
import { Router } from '@angular/router';
import { WFInboxFilterConfig } from 'app/shared/filter/filter.constant';
import { INT_WFINBOX_ACTIONS, WFINBOX} from "app/shared/actions/actions.constants";


@Component({
  selector: "app-myinbox",
  templateUrl: "./myinbox.component.html",
  styleUrls: ["./myinbox.component.scss"],
})
export class MyinboxComponent implements OnInit {
  @Input("ctrlData") ctrlData: any;
  flags = { flagAN: 1, flagAT: 1, flagS: 1, flagDA: 1 };
  ranks = { flagAN: 1, flagAT: 2, flagS: 3, flagDA: 4 };
  sortLabels = {
    flagAN: "ApplicationNumber",
    flagAT: "ApplicationType",
    flagS: "Status",
    flagDA: "DateAssigned",
  };
  direction: boolean = false;
  criteria = "DateAssigned";
  rankCtrl: number = 2;
  activities: any = [];
  isLoading: Boolean = false;
  message: string = "Loading activities, please wait...";
  statuses: any = [];
  keyword: any = {};
  currentPage = 1;
  isEmpty: boolean = false;
  pageSize: number = 10;
  count: number = 0;
  disabled = false;
  ShowFilter = true;
  limitSelection = false;
  selectedItems: any = [];
  dropdownSettings: any = {};
  carrierNumber: string;
  carrierName: string;
  processFlag: boolean = false;
  currentUserName: string = "";
  userData: any = environment.authWebApi.userData;
  workflow_role: number;
  workflow_user: string;
  selectedcarrier: any = null;
  selectedIndex: number;

  companyRegNumber: string;
  first_Name: string;
  surname: string;
  id_number: string;

  CarrierName: string;
  WFAppType: string;
  Status: string;

  filterConfig = WFInboxFilterConfig;

  wfInboxActions = INT_WFINBOX_ACTIONS;


  constructor(
    private service: WorkflowService,
    private carrierService: CarrierService,
    private applicationService: ApplicationService,
    private router: Router,
    private toater: ToastNotificationService,
    private filter: FilterService,
    public utility: UtilityServiceService
  ) {}

  ngOnInit(): void {
    this.workflow_role = this.userData.Roles.find(
      (p) => p.IsWorkflowRole == true
    ).Id;
    this.workflow_user = this.userData.User.UserName;

    this.loadActivities(this.currentPage, this.pageSize);
  }

  loadActivities(page: number = 1, pageSize: number = 10) {
    this.isLoading = true;
    this.service
      .getUserActivity(this.workflow_role, this.workflow_user, page, pageSize)
      .subscribe(
        async (result: any) => {
          this.activities = await this.matchApplications(result);
        },
        (error) => {
          this.toater.error(
            "Failed to load user activity. Please try again",
            "Activity"
          );
          this.isLoading = false;
        }
      );
  }

  matchApplications(results): Observable<any> {
    var listactivities: any = [];
    results.data.forEach((item) => {
        var obj = {
          id: item.id,
          applicationId: item.applicationId,
          applicationType: item.applicationType,
          activityStatus: item.activityStatus,
          dateassigned: item.dateassigned,
          userassigned: item.userAssigned,
          roleassignedid: item.roleAssignedId,
          applicant: item.applicant,
        };

        listactivities.push(obj);

    });

    this.isLoading = false;
    return listactivities;
  }

  onProcess(item) {
    if (item.applicationType == "Carrier Application") {
      this.router.navigate([`/workflow/carrier/approval/${item.applicationId}/${item.roleassignedid}/${item.id}`]);
    } else if (item.applicationType == "Permit Application") {
      this.router.navigate([`/workflow/permit/approval/${item.applicationId}/${item.roleassignedid}/${item.id}`]);
    }else if (item.applicationType == "Annual Compliance") {
        this.router.navigate([`/workflow/compliance/approval/${item.applicationId}/${item.roleassignedid}/${item.id}`]);
    }else{
      this.toater.error('Application type does not have a workflow route','Workflow')
    }
  }

  viewUnassigned(){
    this.router.navigate([`/workflow/unassigned`]);
  }

  //#region Paging
  onNextOrPrevious(page: number = 1) {
    this.loadActivities(page, this.pageSize);
    this.currentPage = page;
    return page;
  }

  onChange = () => {
    this.loadActivities((this.utility.page = 1), this.pageSize);
  };

  //#endregion

  //#region Sorting
  onSort(rank: number) {
    this.direction = !this.direction;
    this.rankCtrl = rank;
    this.onExcuteSort(rank);
    this.loadActivities(this.utility.page, this.pageSize);
  }

  onResetFlags() {
    this.flags = {
      flagAN: 1,
      flagAT: 1,
      flagS: 1,
      flagDA: 1,
    };
  }

  onExcuteSort(rank: number) {
    this.onResetFlags();
    let sort = this.direction ? 3 : 2;
    this.criteria = null;
    switch (rank) {
      case this.ranks.flagAN: {
        this.criteria = this.sortLabels.flagAN;
        this.flags.flagAN = sort;
        break;
      }
      case this.ranks.flagAT: {
        this.criteria = this.sortLabels.flagAT;
        this.flags.flagAT = sort;
        break;
      }
      case this.ranks.flagS: {
        this.criteria = this.sortLabels.flagS;
        this.flags.flagS = sort;
        break;
      }
      case this.ranks.flagDA: {
        this.criteria = this.sortLabels.flagDA;
        this.flags.flagDA = sort;
        break;
      }
      default: {
        this.criteria = this.sortLabels.flagDA;
        this.flags.flagDA = sort;
        break;
      }
    }
  }
  //#endregion

  doPermitAction(event: any) {
    if (event.value == WFINBOX.ViewUnassigned) {
      this.router.navigate([`/workflow/unassigned`]);
    }
  }

  getListData() {
    this.isLoading = true;
   /*  this._service
      .getAdminAnnualCompList(this.currentPage, this.pageSize)
      .subscribe(
        (result: any) => {
          this.annualComplianceListData = result?.m_Item1;
          this.count = result?.m_Item2;
          this.utility.onSort(1);
          this.isLoading = false;
          this.isEmpty = false;
        },
        (error) => {
          this.isEmpty = true;
          this.isLoading = false;
        }
      ); */
  }

  resetPages() {
    this.pageSize = 10;
    this.currentPage = 1;
  }

  applyFilter(filters) {

    console.log(filters)

    this.resetPages();

    if (!filters) {
      this.keyword = {};
      this.loadActivities();
    } else {

    this.selectedItems = filters?.Statuses;
    (this.keyword.WFAppType = filters?.WFAppType? filters?.WFAppType : 0),
    (this.keyword.WFRouteType = filters?.WFRouteType? filters?.WFRouteType : ""),
    (this.keyword.CarrierName = filters?.CarrierName? filters.CarrierName : "ALL"),
    (this.keyword.Statuses = this.selectedItems ? this.selectedItems.map((status) => {  return status.id; }) : []);
    
    if (filters) {
        this.loadFilteredActivities();
        console.log(this.keyword)
      } else {
        this.loadActivities();
      }
    }
  }

  loadFilteredActivities(page: number = 1, pageSize: number = 10) {
    this.isLoading = true;
    this.service
      .getUserActivityFiltered(this.keyword, this.workflow_role, this.workflow_user, page, pageSize)
      .subscribe(
        async (result: any) => {
          this.activities = await this.matchApplications(result);
        },
        (error) => {
          this.toater.error(
            "Failed to load user activity. Please try again",
            "Activity"
          );
          this.isLoading = false;
        }
      );
  }

}
